import React from "react";
import UnleashFuture from "../../images/news1.jpg";
import SvgIconsSet from "../SvgIconsSet";

const resources = [
  {
    id: 1,
    imgSrc: UnleashFuture,
    alt: "Unleashing the Future",
    title: "Unleashing the Future",
    description:
      "A Guide to Seamless AI Integration into Your Existing Systems",
    link: "#",
  },

  {
    id: 2,
    imgSrc: UnleashFuture,
    alt: "Unleashing the Future",
    title: "Maximizing Cloud Investment",
    description: "A Guide for Mid-Size Companies",
    link: "#",
  },
];

const Resources = () => {
  return (
    <div className="section-resources">
      {resources.map((item) => (
        <div id={item.id} className="resources-card">
          <div className="section-resources-img">
            <img src={item.imgSrc} alt={item.alt} />
          </div>
          <div className="section-resources-dec">
            <div className="section-resources-card-title">{item.title}</div>
            <div className="section-resources-card-dec">{item.description}</div>
            <a href="#" class="btn btn-primary btn-icon-button">
              <span className="btn-text">Read more</span>
              <span className="btn-icon">
                <SvgIconsSet.SideArrow />
              </span>
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Resources;
